module.exports = __webpack_public_path__ + "static/media/cnb2.3b0b8deb.png";